import Invoice from './partial/invoice'
import Finance from './partial/finance'
import Insurance from './partial/insurance'
import Log from './partial/bindlog'
// import Review from './partial/review'
// import InstallationInfo from './partial/installation-info'
import global from '@/util/mixin/global'
export default {
  mixins:[global],
  data() {
    return {
      carNo: null,
      loading: false,
      data: {},
      visible: false,
    }
  },
  methods: {
    init(carNo) {
      this.carNo = carNo
      this.visible = true

      if (carNo) {
        this.query(carNo)
      }
    },

    query(carNo) {
      this.loading = true
      this.$request.partnerCar(carNo).then(resp => {
        this.loading = false
        if (resp.code == 0) {

          // resp.data.partsList = this.$utils.conv(resp.data.partsList || [], {'genre':'genre'})
          resp.data.carBattery = this.$utils.conv(resp.data.carBattery, { 'type': 'batteryType' })
          this.data = this.$utils.conv(resp.data, { 'enrollDatetime': 'datetime', 'reviewDatetime': 'datetime', 'reviewResult': 'stdInstallationReviewResult','batteryType':'batteryType' })

        } else {
          this.$Message.error({ content: resp.msg })
        }
      })
    },
  },
  render() {
    const { loading, data } = this
    const title = '车辆详情'
    const battery = data.carBattery || {}

    //0 金融+保险 / 1 金融 / 2 保险
    const financeViewable = data.financeCompanyName == this.subject.cooperativeCompanyName
    //隐藏保险方案名 : 
    const insuranceViewable = data.insuranceCompanyName == this.subject.cooperativeCompanyName
    const tabs = []

    if( financeViewable ){
      tabs.push(
        <TabPane label="费用明细" name="t2">
            <Invoice car-no={data.carNo} />
          </TabPane>,
        <TabPane label="金融方案" name="t3">
          <Finance car-no={data.carNo} />
        </TabPane>
      )
    }
    if( insuranceViewable ){
      tabs.push(
        <TabPane label="保险方案" name="t4">
          <Insurance car-no={data.carNo} />
        </TabPane>
      )
    }
    
    return (
      <sl-side-panel destroyOnClose={true} v-model={this.visible} mask-closable={false} title={title} loading={loading}>
        <Tabs value="t1">
          <TabPane label="基本信息" name="t1">
            <sl-detail-list layout="vertical" col={4} label-width="100px" label-align="right" style="padding:12px;">
              <sl-detail-list-item title="车辆类型">{data.categoryName}</sl-detail-list-item>
              <sl-detail-list-item title="车牌号">{data.licenseNo}</sl-detail-list-item>
              <sl-detail-list-item title="所属企业">{data.companyName}</sl-detail-list-item>
              <sl-detail-list-item title="生产日期">{data.enrollDatetimeText}</sl-detail-list-item>
              <sl-detail-list-item title="车辆编号">{data.carNo}</sl-detail-list-item>
              <sl-detail-list-item title="车辆品牌">{data.brand}</sl-detail-list-item>
              <sl-detail-list-item title="IMEI">{data.imei}</sl-detail-list-item>
              <sl-detail-list-item title="车架号">{data.frameNo}</sl-detail-list-item>
              <sl-detail-list-item title="电池规格">{battery.specs}</sl-detail-list-item>
              <sl-detail-list-item title="电机号">{data.motorNo}</sl-detail-list-item>
              <sl-detail-list-item title="电池序号">{battery.batteryNo}</sl-detail-list-item>
              <sl-detail-list-item title="电池品牌">{battery.brand}</sl-detail-list-item>
              <sl-detail-list-item title="电池类型">{battery.typeText}</sl-detail-list-item>
              <sl-detail-list-item title="保单号">{data.insuranceNo}</sl-detail-list-item>
              <sl-detail-list-item title="合格证编号">{data.certNo}</sl-detail-list-item>
              <sl-detail-list-item title="一致性证书编号">{data.cocNo}</sl-detail-list-item>
              <sl-detail-list-item title="颜色">{data.color}</sl-detail-list-item>
            </sl-detail-list>
            <sl-detail-list layout="vertical" col={1} label-width="100px" label-align="right" style="padding:12px;">
              <sl-detail-list-item title="照片">
                {
                  data.photo ? <sl-carousel images={data.photo.split(';')} /> : null
                }
              </sl-detail-list-item>
              <sl-detail-list-item title="备注">
                {data.remark}
              </sl-detail-list-item>
            </sl-detail-list>
          </TabPane>
          {tabs}
          <TabPane label="使用记录" name="t5">
            <Log car-no={data.carNo} />
          </TabPane>
        </Tabs>

      </sl-side-panel>
    )
  }
}
